var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"col-start-2 col-end-12 row-start-5 row-end-6"},[_c('div',{staticClass:"pb-16 md:pt-16 xxl:px-6 container mx-auto overflow-hidden",attrs:{"id":"features-container"}},[_c('features-one'),_c('features-two')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }